<form [formGroup]="accountForm">
  <div class="container add-account">
    <div class="row">
      <h2 class="text-center">Agregar cuenta bancaria</h2>

      <div class="col-12 col-md-6 pt-4 mt-1 mb-3">
        <div class="form-password floating-label-input">
          <input class="form-control cssToolTip" upperCase id="alias" type="text" aria-describedby="alias"
            formControlName="alias" placeholder="Alias" autocomplete="off">
          <label class="form-label fs-13" for="alias">Alias</label>
          <img src="assets/icons/check-input.svg" class="check-img" alt="" *ngIf="account.alias.valid">
          <div class="error-txt" *ngIf="account.alias.invalid">
            <span *ngIf="account.alias.invalid && account.alias.dirty && account.alias.touched
               && account.alias.value" class="text-red small text-right">
              El formato de alias es incorrecto.
            </span>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6 pt-4 mt-1 mb-3">
        <div class="floating-label-input">
          <mat-form-field appearance="outline" class="mnf-select">
            <mat-select formControlName="bankId" placeholder="Banco">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Buscar" noEntriesFoundLabel="No encontrado"
                  formControlName="bankFilter" (ngModelChange)="bankFilter($event)">
                  <div class="close-search" ngxMatSelectSearchClear>X</div>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option [value]="bank.id" *ngFor="let bank of filteredBanks | async;" [title]="bank.name">
                {{ bank.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <label for="inputState" class="form-label"
            [ngClass]="accountForm.controls.bankId.value ? 'd-block' : ''">Banco</label>
        </div>
      </div>

      <div class="col-12 pt-4 mt-1 mb-3">
        <div class="form-password floating-label-input">
          <input class="form-control cssToolTip" maxlength="18" id="clabe" type="text"
            aria-describedby="clabe" mask="9{18}" formControlName="clabe" placeholder="Clabe" autocomplete="off">
          <label class="form-label fs-13" for="Clabe">Clabe</label>
          <img src="assets/icons/check-input.svg" class="check-img" alt="" *ngIf="account.clabe.valid">
          <div class="error-txt mb-4" *ngIf="account.clabe.invalid">
            <span *ngIf="account.clabe.invalid && account.clabe.dirty && account.clabe.touched
               && account.clabe.value" class="text-red small text-right">
              El formato de clabe es incorrecto.
            </span>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6 offset-md-3">
        <button type="submit" mat-button class="action" [disabled]="accountForm.invalid">
          Agregar
        </button>
      </div>
    </div>
  </div>
</form>
